
import { Button } from "@/components/ui/button";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface TestEmailHeaderProps {
  email: string;
  loading: boolean;
  onRefresh: () => void;
  onClear: () => void;
}

const TestEmailHeader = ({ email, loading, onRefresh, onClear }: TestEmailHeaderProps) => {
  return (
    <CardHeader>
      <div className="flex justify-between items-center">
        <CardTitle>Test Emails</CardTitle>
        <div className="space-x-2">
          <Button variant="outline" onClick={onRefresh} disabled={loading}>
            {loading ? "Loading..." : "Refresh"}
          </Button>
          <Button variant="destructive" onClick={onClear} disabled={loading}>
            Clear All
          </Button>
        </div>
      </div>
      <CardDescription>
        Test emails for {email}
      </CardDescription>
    </CardHeader>
  );
};

export default TestEmailHeader;
